import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import history from '@/utils/common/history';

const useBlockNavigation = (setIsShowPopup: React.Dispatch<React.SetStateAction<boolean>>) => {
  const location = useLocation();

  useEffect(() => {
    const unlisten = history.listen((locationData) => {
      if (locationData.action === 'POP') {
        // 같은 페이지 내 해시만 변경되는 경우(탭 전환)에는 나가기 팝업 띄우지 않음
        if (locationData.pathname === location.pathname) {
          return;
        }
        setIsShowPopup(true);
        history.push(location.pathname);
      }
    });

    return () => {
      unlisten();
    };
  }, [location.pathname, setIsShowPopup]);
};

export default useBlockNavigation;
